import { render, staticRenderFns } from "./icon-link.vue?vue&type=template&id=7e48f46e&scoped=true"
import script from "./icon-link.vue?vue&type=script&lang=js"
export * from "./icon-link.vue?vue&type=script&lang=js"
import style0 from "./icon-link.vue?vue&type=style&index=0&id=7e48f46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48f46e",
  null
  
)

export default component.exports